import React from "react";
import {
  Eye, Copy, Send, Archive, ArchiveRestore,
  CheckCircle, XCircle, Trash2
} from "lucide-react";

export function QuoteActionsMenu({ 
  quoteId, 
  isArchived,
  onView,
  onCreateVersion,
  onUpdateStatus,
  onArchive,
  onDelete,
  onClose,
}) {
  return (
    <div 
      className="absolute right-0 top-full mt-1 w-48 bg-white border border-slate-200 rounded-lg shadow-lg z-20 py-1"
      data-testid={`action-menu-${quoteId}`}
    >
      <button
        data-testid={`view-quote-${quoteId}`}
        onClick={() => { onView(); onClose(); }}
        className="w-full px-4 py-2 text-left text-sm text-slate-700 hover:bg-slate-50 flex items-center gap-2"
      >
        <Eye size={14} /> View Quote
      </button>
      <button
        data-testid={`new-version-${quoteId}`}
        onClick={onCreateVersion}
        className="w-full px-4 py-2 text-left text-sm text-slate-700 hover:bg-slate-50 flex items-center gap-2"
      >
        <Copy size={14} /> Save as New Version
      </button>
      <div className="border-t border-slate-100 my-1"></div>
      <button
        data-testid={`status-pending-${quoteId}`}
        onClick={() => onUpdateStatus("pending")}
        className="w-full px-4 py-2 text-left text-sm text-slate-700 hover:bg-slate-50 flex items-center gap-2"
      >
        <Send size={14} /> Mark as Pending
      </button>
      <button
        data-testid={`status-approved-${quoteId}`}
        onClick={() => onUpdateStatus("approved")}
        className="w-full px-4 py-2 text-left text-sm text-emerald-600 hover:bg-emerald-50 flex items-center gap-2"
      >
        <CheckCircle size={14} /> Mark as Approved
      </button>
      <button
        data-testid={`status-rejected-${quoteId}`}
        onClick={() => onUpdateStatus("rejected")}
        className="w-full px-4 py-2 text-left text-sm text-red-600 hover:bg-red-50 flex items-center gap-2"
      >
        <XCircle size={14} /> Mark as Rejected
      </button>
      <div className="border-t border-slate-100 my-1"></div>
      {isArchived ? (
        <button
          data-testid={`unarchive-${quoteId}`}
          onClick={() => onArchive(false)}
          className="w-full px-4 py-2 text-left text-sm text-slate-700 hover:bg-slate-50 flex items-center gap-2"
        >
          <ArchiveRestore size={14} /> Restore from Archive
        </button>
      ) : (
        <button
          data-testid={`archive-${quoteId}`}
          onClick={() => onArchive(true)}
          className="w-full px-4 py-2 text-left text-sm text-amber-600 hover:bg-amber-50 flex items-center gap-2"
        >
          <Archive size={14} /> Archive
        </button>
      )}
      <button
        data-testid={`delete-${quoteId}`}
        onClick={onDelete}
        className="w-full px-4 py-2 text-left text-sm text-red-600 hover:bg-red-50 flex items-center gap-2"
      >
        <Trash2 size={14} /> Delete
      </button>
    </div>
  );
}
